import moment from 'moment';
import React from 'react';
import LocalizedMessage from 'react-l10n';

const RefineResultActiveFilterItem = ({ item, onRemoveClick }) => {
    const { key, label, value } = item;
    var valueTransform = ''
    const DATE_FIELD_FORMAT = 'DD/MM/YYYY';
    const DATE_FIELD_SAVED_FORMAT = 'YYYY-MM-DD';
    if (key==='Placed__GTE' || key==='Placed__LTE'){
        valueTransform =  moment(value , DATE_FIELD_SAVED_FORMAT).format(
            DATE_FIELD_FORMAT
        )
    }
    else {
        valueTransform = value
    }

    if (key.substr(0, 7) == 'ignore:') {
        return '';
    }

    return (
        <div className='refine-results__item'>
            <div className='refine-results__label micro-heading'>{label}</div>
            <div className='refine-results__pill'>
                <span className='refine-results__pill__tex+++++++t'>"{valueTransform}"</span>
                <button
                    type='button'
                    className='refine-results__pill__remove'
                    title='Remove filter'
                    onClick={() => onRemoveClick(key)}
                >
                    <span className='icon icon-close-thick' />
                </button>
            </div>
        </div>
    );
};

const RefineResultActiveFilters = ({
    clearAllFilters,
    clearFilter,
    activeFilters,
    ignoreDisplayingFilters,
}) => {
    let displayedActiveFilters = [];

    activeFilters.forEach((item) => {
        const { key } = item;
        let ignoreStatus = false;

        if (key.substr(0, 7) == 'ignore:') {
            ignoreStatus = true;
        }
        if (
            typeof ignoreDisplayingFilters != 'undefined' &&
            ignoreDisplayingFilters.length &&
            ignoreDisplayingFilters.indexOf(key) != -1
        ) {
            ignoreStatus = true;
        }

        if (!ignoreStatus) {
            displayedActiveFilters.push(item);
        }
    });

    if (displayedActiveFilters.length == 0) {
        return '';
    }

    return (
        <div className='refine-results' id='refine-reports-list'>
            <div className='refine-results__header'>
                <div className='row row--vcenter'>
                    <div className='col-xs-6'>
                        <span className='refine-results__heading'>
                            <LocalizedMessage id={'ACTIVE_FILTERS'} />
                        </span>
                    </div>
                    <div className='col-xs-6 tx-right'>
                        <button
                            type='button'
                            className='refine-results__clear'
                            onClick={() => clearAllFilters()}
                        >
                            <LocalizedMessage id={'CLEAR_ALL_FILTERS'} />
                        </button>
                    </div>
                </div>
            </div>
            <div className='refine-results__list'>
                {displayedActiveFilters.map((activeFilter, key) => {
                    if (activeFilter.key !== 'Sort') {
                        return (
                            <RefineResultActiveFilterItem
                                key={key}
                                item={activeFilter}
                                onRemoveClick={(key) => clearFilter(key)}
                            />
                        );
                    }

                    return null;
                })}
            </div>
        </div>
    );
};

export default RefineResultActiveFilters;
